import { RouteConfig } from "vue-router";
import Home from "@/views/mobile/home/index.vue";
import Tickets from "@/views/mobile/tickets/index.vue";
import Checkout from "@/views/mobile/checkout/index.vue";
import Notify from "@/views/mobile/notify/index.vue";
import Inspiring from "@/views/mobile/inspiring/Inspiring.vue";
import AboutUs from "@/views/mobile/static-pages/AboutUs.vue";
// import Green from "@/views/mobile/static-pages/Green.vue";
import HowTo from "@/views/mobile/static-pages/HowTo.vue";
import TermCondition from "@/views/mobile/static-pages/TermCondition.vue";
import News from "@/views/mobile/static-pages/News.vue";
import Draws from "@/views/mobile/static-pages/Draws.vue";
import ListDraws from "@/views/mobile/static-pages/ListDraws.vue";
import PastDraws from "@/views/mobile/static-pages/PastDraws.vue";
import Winners from "@/views/mobile/static-pages/ListWinners.vue";
import ContactUs from "@/views/mobile/static-pages/ContactUs.vue";
import OasisPark from "@/views/mobile/static-pages/OasisPark.vue";
import LandingPage from "@/views/mobile/landing-page/index.vue";
import BuyNow from "@/views/mobile/buy-now/index.vue";

const publicRoutes: Array<RouteConfig> = [
    {
        path: "/",
        name: "LandingPage",
        meta: { isShowFooter: true },
        component: LandingPage,
    },
    {
        path: "/tickets",
        name: "Tickets",
        component: Tickets,
    },
    {
        path: "/home",
        redirect: { name: 'Tickets' }
    },
    {
        path: "/buy/green-certificates",
        name: "BuyNow",
        meta: { isShowFooter: true },
        component: BuyNow,
    },
    {
        path: "/checkout",
        name: "Checkout",
        component: Checkout,
    },
    {
        path: "/notify",
        name: "Notify",
        component: Notify,
    },
    {
        path: "/thank-you",
        name: "Inspiring",
        component: Inspiring,
    },
    {
        path: "/about-us",
        name: "AboutUs",
        meta: { isShowFooter: true },
        component: AboutUs,
    },
    // {
    //     path: "/green",
    //     name: "Green",
    //     meta: { isShowFooter: true },
    //     component: Green,
    // },
    {
        path: "/how-to",
        name: "HowTo",
        meta: { isShowFooter: true },
        component: HowTo,
    },
    {
        path: "/term-conditions",
        name: "TermConditions",
        meta: { isShowFooter: true },
        component: TermCondition,
    },
    {
        path: "/draws",
        name: "Draws",
        meta: { isShowFooter: true },
        component: Draws,
    },
    {
        path: "/list-draws",
        name: "ListDraws",
        component: ListDraws,
    },
    {
        path: "/past-draws",
        meta: { isShowFooter: true },
        name: "PastDraws",
        component: PastDraws,
    },
    {
        path: "/winners",
        name: "Winners",
        component: Winners,
    },
    {
        path: "/news",
        name: "News",
        meta: { isShowFooter: true },
        component: News,
    },
    {
        path: "/contact-us",
        name: "ContactUs",
        meta: { isShowFooter: true },
        component: ContactUs,
    },
    {
        path: "/oasis-park",
        name: "OasisPark",
        meta: { isShowFooter: true },
        component: OasisPark,
    },
];

export default publicRoutes;
